module.exports = __webpack_public_path__ + "static/media/icon_private-investing.2953f7ac.svg";